export default class ResourceLocator {
    constructor() {
        this.location = window.location;
        this.saveTagsInUrl = [
            'gclid', 'utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'
        ];
    }

    urlOptions(resetGoogleTag) {
        let searchString = this.location.search;
        let anchor = '';
        let fullSearchString = this.location.toString().replace('%23', '#');
        let arrayAnchor = fullSearchString.split('#');
        if (arrayAnchor.length  === 2) {
            anchor = '#' + arrayAnchor[1];
            searchString = this.location.search.split('%23').shift();
        }
        let keysStr = searchString.substr(1);
        let keysArr = keysStr.split('=');
        if (keysArr.length) {
            if (keysArr[0] === 'group') {
                return searchString;
            }
            if (resetGoogleTag) {
                return ''
            }

            let queryParams = searchString.replace(/^(\?)/,"").split('&');
            let result = queryParams.filter((param)  => {
                let paramArray = param.split('=');
                return this.saveTagsInUrl.indexOf(paramArray[0]) >= 0;
            });
            let totalResult =  result.join('&');
            if (totalResult.length > 0) {
                totalResult = `?${totalResult}`;
            }
            return anchor +  totalResult;
        }

        return '';
    }
}